import {
  FicheDePrep,
  Sequence,
  SequenceApi,
} from '@teetsh/app/src/types/sequences';
import { BoFields } from '@teetsh/app/src/types/bo';
import {
  deserializeItems,
  serializeItems,
} from '@teetsh/app/src/queries/serializer';
import { Niveau } from '@teetsh/app/src/types/classroom';
import emptyBo from '@teetsh/app/src/components/Bo/emptyBo';
import {
  DEFAULT_CYCLE,
  ScholarSystems,
  getNiveauFromScholarSystemOrDefault,
} from '@teetsh/app/src/containers/scholarSystem';

export const defaultToEmptyArray = item => {
  if (!item || item === null) {
    return [];
  }
  return item;
};

export function deserializeFicheDePreps(fdpFromApi): FicheDePrep {
  const {
    competence,
    goals,
    domaine,
    matiere,
    cycle,
    attachments,
    materials,
    phases,
    ...rest
  } = fdpFromApi;
  return {
    ...rest,
    attachments: attachments || [],
    bo: {
      competence: serializeItems(defaultToEmptyArray(competence)),
      goals: serializeItems(defaultToEmptyArray(goals)),
      domaine: serializeItems(defaultToEmptyArray(domaine)),
      matiere: serializeItems(defaultToEmptyArray(matiere)),
      cycle: cycle || DEFAULT_CYCLE,
    },
    phases: defaultToEmptyArray(phases).map(phase => ({
      ...phase,
      types: serializeItems(phase.types),
      dispositifs: serializeItems(phase.dispositifs),
    })),
    materials: serializeItems(materials),
  };
}

function getCycleFromSequence(niveaux: Niveau[], cycle: string): string {
  if (cycle) {
    return cycle;
  }
  if (!niveaux || niveaux.length === 0) {
    return DEFAULT_CYCLE;
  }

  return (
    getNiveauFromScholarSystemOrDefault(ScholarSystems.FR, niveaux[0]).cycle ||
    DEFAULT_CYCLE
  );
}

export function deserializeSequence(sequence: SequenceApi): Sequence {
  const { competence, goals, domaine, matiere, cycle, ...rest } = sequence;

  const niveaux = (sequence.niveaux || []) as Niveau[];
  return {
    ...rest,
    niveaux,
    bo: {
      competence: serializeItems(defaultToEmptyArray(competence)),
      goals: serializeItems(defaultToEmptyArray(goals)),
      domaine: serializeItems(defaultToEmptyArray(domaine)),
      matiere: serializeItems(defaultToEmptyArray(matiere)),
      cycle: getCycleFromSequence(niveaux, sequence.cycle),
    },
    fichesDePrep: (rest.fichesDePrep || []).map(fdp =>
      deserializeFicheDePreps(fdp),
    ),
  };
}

export const serializeFicheDePreps = (ficheDePrep: FicheDePrep) => {
  const { bo, phases, ...rest } = ficheDePrep;
  return {
    ...rest,
    attachments: ficheDePrep.attachments || [],
    materials: deserializeItems(ficheDePrep.materials),
    competence: deserializeItems(bo?.competence || []),
    matiere: deserializeItems(bo?.matiere || []),
    goals: deserializeItems(bo?.goals || []),
    domaine: deserializeItems(bo?.domaine || []),
    cycle: bo?.cycle,
    phases: defaultToEmptyArray(phases).map(phase => ({
      ...phase,
      types: deserializeItems(phase.types),
      dispositifs: deserializeItems(phase.dispositifs),
    })),
  };
};

export function serializeSequence(sequence: Sequence) {
  const { bo, ...rest } = sequence;
  const sequenceBo: BoFields = bo || emptyBo;

  return {
    ...rest,
    matiere: deserializeItems(sequenceBo.matiere),
    fichesDePrep: ((sequence.fichesDePrep || []) as any).map(
      (fdp: FicheDePrep) => serializeFicheDePreps(fdp),
    ),
    competence: deserializeItems(sequenceBo.competence),
    goals: deserializeItems(sequenceBo.goals),
    domaine: deserializeItems(sequenceBo.domaine),
    cycle: sequenceBo.cycle,
  };
}
